import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	descriptionContainer: {
		marginBottom: theme.spacing(8),
		marginTop: theme.spacing(5)
		// backgroundColor: COLORS.FOOTER_GREY,
		// borderTop: '1px solid rgb(220,220,220)',
		// borderBottom: '1px solid rgb(220,220,220)',
	},
	text: {
		marginTop: theme.spacing(6)
	}
}));
